import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { JobsPage } from './_dashboard.devices.jobs'

export const Route = createFileRoute('/_dashboard/devices/jobs/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: JobsIndexPage,
})

function JobsIndexPage() {
  return <JobsPage selectedId={undefined} />
}
